/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Location/view.blocks to change it.
import PaymentProviderLocation from 'DesignSystem/PaymentProvider/PaymentProviderLocation/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Location({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Empty/Location"
  
}) {
  return (<React.Fragment
>
<PaymentProviderLocation
  viewPath={`${viewPath}/PaymentProviderLocation`}
/>
{children}
</React.Fragment>)
}